import { createSelector } from "reselect";
import { getActiveLocation } from "./getLocationLocale";

/** Whether this venue has been moved onto the guest platform fee. Absent means not. */
export const getGuestPlatformFeeEnabled = createSelector(
    getActiveLocation,
    (location) => location?.guestPlatformFeeEnabled ?? false
);
